var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 18H10C10 19.1046 9.1046 20 8 20C6.8954 20 6 19.1046 6 18Z",
    fill: "#86898E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99951 0C7.44721 0 6.99951 0.44772 6.99951 1V2C6.99951 2.02775 7.00061 2.05523 7.00281 2.08241C4.16352 2.55712 1.99955 5.02585 1.99955 8V9.9574C1.99955 10.3881 1.84364 10.8042 1.56063 11.1289L0.916191 11.8682C-1.17063 14.2623 0.529701 18 3.7056 18H12.2935C15.4694 18 17.1697 14.2623 15.0829 11.8682L14.4385 11.1289C14.1555 10.8042 13.9995 10.3881 13.9995 9.9574V8C13.9995 5.02582 11.8355 2.55707 8.99621 2.08239C8.99841 2.05522 8.99951 2.02774 8.99951 2V1C8.99951 0.44772 8.55181 0 7.99951 0ZM3.99955 8C3.99955 5.79086 5.79041 4 7.99951 4C10.2087 4 11.9995 5.79086 11.9995 8V9.9574C11.9995 10.8712 12.3303 11.7542 12.9308 12.443L13.5753 13.1824C14.5342 14.2825 13.7529 16 12.2935 16H3.7056C2.24623 16 1.46491 14.2825 2.42383 13.1824L3.06827 12.443C3.66875 11.7542 3.99955 10.8712 3.99955 9.9574V8Z",
    fill: "#86898E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group (5).13ce643df28e57f5fbcae9f180e999a3.svg";
export { ForwardRef as ReactComponent };